import { render, staticRenderFns } from "./commonHeader.vue?vue&type=template&id=32660be0&scoped=true&"
import script from "./commonHeader.vue?vue&type=script&lang=ts&"
export * from "./commonHeader.vue?vue&type=script&lang=ts&"
import style0 from "./commonHeader.vue?vue&type=style&index=0&id=32660be0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32660be0",
  null
  
)

export default component.exports